import type { FC } from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import StudioBlankSlate from '../../StudioBlankSlate';
import ProductSalesSection from '../SoldProducts';
import SubscriptionSalesSection from '../SoldSubscriptions';
import TopSellingProductsSection from '../TopSellingProductsSection';
import TopCustomersSection from '../TopCustomersSection';
import SoldExclusivesSection from '../SoldExclusivesSection';
import TopSubscribersSection from '../TopSubscribersSection';
import SubsCancellationReasonsSection from '../SubsCancellationReasonsSection';

import s from './ShopReportsPageContent.scss';

export interface Props {
  hasData: boolean;
}

const ShopReportsPageContent: FC<Props> = ({ hasData }) => {
  if (!hasData) {
    return (
      <div className={s['root']}>
        <Flex direction="column" alignItems="center" justifyContent="center" fullHeight>
          <StudioBlankSlate />
        </Flex>
      </div>
    );
  }

  return (
    <div className={s['root']}>
      <ProductSalesSection className={s['products']} />
      <SoldExclusivesSection className={s['sold-exclusives']} />
      <SubscriptionSalesSection className={s['subscriptions']} />
      <TopSubscribersSection className={s['top-subscribers']} />
      <SubsCancellationReasonsSection className={s['subs-cancellation-reasons']} />
      <TopSellingProductsSection className={s['top-products']} />
      <TopCustomersSection className={s['top-customers']} />
    </div>
  );
};
ShopReportsPageContent.displayName = 'ShopReportsPageContent';

export default ShopReportsPageContent;
